import type { FC, PropsWithChildren } from 'react'
import type { RadioProps, RadioGroupProps } from 'antd/es/radio'

import {
  SC_RadioGroup,
  SC_Radio,
  SC_RadioButton,
} from './styled'


export type T_RadioProps = RadioProps

export type T_RadioGroupProps = {
  customType?: 'view-page' | 'column' | 'fuel' | 'volume' | 'payment'
} & RadioGroupProps

type T_CompoundedComponent = FC<PropsWithChildren<T_RadioProps>> & {
  Group: FC<PropsWithChildren<T_RadioGroupProps>>
  Button: FC<PropsWithChildren<T_RadioProps>>
}

export const Radio: T_CompoundedComponent = (props) => {
  const { children, ...restProps } = props

  return (
    <SC_Radio {...restProps}>
      {children}
    </SC_Radio>
  )
}

Radio.Group = (props: PropsWithChildren<T_RadioGroupProps>) => {
  const { children, ...restProps } = props

  return (
    <SC_RadioGroup {...restProps}>
      {children}
    </SC_RadioGroup>
  )
}

Radio.Button = (props: PropsWithChildren<T_RadioProps>) => {
  const { children, ...restProps } = props

  return (
    <SC_RadioButton {...restProps}>
      {children}
    </SC_RadioButton>
  )
}
